import React, { useState, useEffect, useRef } from 'react';
import { Box, TextField, Chip, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getCategoryLabel } from './appStoreUtils';

function AppSearchBar({ searchQuery, onSearchChange, categories, activeCategories, onCategoryToggle }) {
  const [localQuery, setLocalQuery] = useState(searchQuery);
  const debounceRef = useRef(null);

  // Debounce della ricerca a 200ms
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onSearchChange(localQuery);
    }, 200);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [localQuery, onSearchChange]);

  return (
    <Box sx={{ mb: 3 }}>
      <TextField
        fullWidth
        placeholder="Cerca applicazioni..."
        value={localQuery}
        onChange={(e) => setLocalQuery(e.target.value)}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
        sx={{ mb: 1.5 }}
      />
      {categories.length > 1 && (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip
            label="Tutti"
            size="small"
            onClick={() => onCategoryToggle(null)}
            color={activeCategories.length === 0 ? 'primary' : 'default'}
            variant={activeCategories.length === 0 ? 'filled' : 'outlined'}
          />
          {categories.map(cat => (
            <Chip
              key={cat}
              label={getCategoryLabel(cat)}
              size="small"
              onClick={() => onCategoryToggle(cat)}
              color={activeCategories.includes(cat) ? 'primary' : 'default'}
              variant={activeCategories.includes(cat) ? 'filled' : 'outlined'}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}

export default AppSearchBar;
